<!--
  The sidemenu. Two shapes from one set of groups (see the component): expanded, where a group
  is a labelled row that opens onto its pages; and collapsed, where a group is just its icon.
  Everything here comes from NAV_ITEMS, so what a role may see is decided in one place.
-->
<div class="sidebar snav" [ngClass]="expanded ? 'open' : ''">

  <!-- The mark doubles as the toggle, which is where it has always been. -->
  <button type="button" class="snav__head" (click)="toggleSidebar()"
          [attr.aria-label]="expanded ? 'Collapse menu' : 'Expand menu'"
          [attr.aria-expanded]="expanded"
          [matTooltip]="expanded ? '' : 'Expand menu'" matTooltipPosition="right"
          matTooltipClass="global-tooltip">
    <!-- Expanded, the lockup is one asset (mark and wordmark together); collapsed, the mark
         alone is all there is room for. -->
    <img *ngIf="expanded" class="snav__lockup" src="assets/img/SyncedBlackLogo.svg" alt="Synced" />
    <img *ngIf="!expanded" class="snav__logo" src="assets/img/sidebar/synced-black-logo.png" alt="Synced" />
  </button>

  <nav class="snav__body" aria-label="Main">

    <!-- Loading. One bar per menu row, from the same config as the menu itself. -->
    <ng-container *ngIf="isLoading">
      <div class="snav__skeleton" *ngFor="let row of skeletonRows; trackBy: trackRow" aria-hidden="true">
        <span class="snav__skeleton-icon"></span>
        <span class="snav__skeleton-bar" *ngIf="expanded"></span>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading">
      <ng-container *ngFor="let group of topGroups; trackBy: trackGroup">

        <!-- Ungrouped: Home. A row that is a link in both shapes. -->
        <a *ngIf="!group.section" class="snav__row" [class.is-active]="isItemActive(group.items[0])"
           [routerLink]="group.items[0].route" (click)="onItemClick($event, group.items[0])"
           [matTooltip]="expanded ? '' : group.items[0].label" matTooltipPosition="right"
           matTooltipClass="global-tooltip">
          <img class="snav__icon" [src]="iconPath(group.items[0], isItemActive(group.items[0]))" alt="" />
          <span class="snav__label" *ngIf="expanded">{{ group.items[0].label }}</span>
          <!-- SD-1248: All clients counts the clients needing action. -->
          <span class="snav__badge" *ngIf="badgeFor(group.items[0]) > 0"
                [attr.aria-label]="badgeFor(group.items[0]) + ' need action'">{{ badgeFor(group.items[0]) }}</span>
        </a>

        <ng-container *ngIf="group.section">

          <!-- Expanded: the group's row goes to its first page, and the chevron beside it opens
               and closes the group. Two controls rather than one, so that neither costs the
               other: the row is still a link you can middle-click. -->
          <ng-container *ngIf="expanded">
            <div class="snav__row snav__row--group" [class.is-active]="isGroupActive(group)">
              <a class="snav__grouplink" [routerLink]="group.items[0].route"
                 (click)="onGroupClick($event, group)">
                <img class="snav__icon" [src]="groupIcon(group, isGroupActive(group))" alt="" />
                <span class="snav__label">{{ group.section.label }}</span>
              </a>
              <button type="button" class="snav__chevbtn" (click)="toggleGroup(group)"
                      [attr.aria-expanded]="isGroupOpen(group)"
                      [attr.aria-label]="(isGroupOpen(group) ? 'Collapse ' : 'Expand ') + group.section.label">
                <svg class="snav__chev" [class.is-open]="isGroupOpen(group)" width="14" height="14"
                     viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </button>
            </div>

            <div class="snav__children" *ngIf="isGroupOpen(group)">
              <a class="snav__child" *ngFor="let item of group.items; trackBy: trackItem"
                 [class.is-active]="isItemActive(item)"
                 [routerLink]="item.route" (click)="onItemClick($event, item)">
                {{ item.label }}
              </a>
            </div>
          </ng-container>

          <!-- Collapsed: one icon for the group, which goes to its first page. -->
          <a *ngIf="!expanded" class="snav__row" [class.is-active]="isGroupActive(group)"
             [routerLink]="group.items[0].route" (click)="onGroupIconClick($event, group)"
             [matTooltip]="group.section.label" matTooltipPosition="right"
             matTooltipClass="global-tooltip">
            <img class="snav__icon" [src]="groupIcon(group, isGroupActive(group))" alt="" />
          </a>

        </ng-container>
      </ng-container>
    </ng-container>
  </nav>

  <div class="snav__foot" *ngIf="!isLoading">
    <ng-container *ngFor="let group of bottomGroups; trackBy: trackGroup">
      <ng-container *ngFor="let item of group.items; trackBy: trackItem">

        <!-- Support is an action, not a destination: it toggles the Intercom launcher, so it
             has no routerLink and tracks its own open state. -->
        <button type="button" class="snav__row" *ngIf="item.action === 'support'"
                [class.is-active]="supportOpen" (click)="onItemClick($event, item)"
                [matTooltip]="expanded ? '' : item.label" matTooltipPosition="right"
                matTooltipClass="global-tooltip">
          <img class="snav__icon" [src]="iconPath(item, supportOpen)" alt="" />
          <span class="snav__label" *ngIf="expanded">{{ item.label }}</span>
        </button>

        <a class="snav__row" *ngIf="!item.action" [class.is-active]="isItemActive(item)"
           [routerLink]="item.route" (click)="onItemClick($event, item)"
           [matTooltip]="expanded ? '' : item.label" matTooltipPosition="right"
           matTooltipClass="global-tooltip">
          <img class="snav__icon" [src]="iconPath(item, isItemActive(item))" alt="" />
          <span class="snav__label" *ngIf="expanded">{{ item.label }}</span>
        </a>

      </ng-container>
    </ng-container>
  </div>
</div>
